import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  /** なぜ空なのか、次に何をすればよいか。 */
  description?: string;
  action?: ReactNode;
}

/** 一覧が0件のときの表示。読み込み失敗はProblemNoticeで出し、ここと混ぜない。 */
export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <p className="empty-state-title">{title}</p>
      {description === undefined ? null : <p className="empty-state-description">{description}</p>}
      {action === undefined ? null : <div className="empty-state-action">{action}</div>}
    </div>
  );
}
